export const callWFAPI = async (
  moduleId: number,
  type: string,
  params: object,
): Promise<any> => {
  const data = {
    id: 1,
    domain: 'websiteforge.com',
    wfuserlogin: 'lgannon',
    wfuserpassword: 'afdJH75fdaA',
    moduleid: moduleId,
    type: type,
    data: params,
  }
  const response = await fetch('https://secure.wf-api.com/core/webservice', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  if (!response.ok) {
    throw new Error(`API Error: ${response.status}`)
  }
  const resp = await response.json()
  if (resp['ErrorText']) {
    throw new Error(resp['ErrorText'])
  }
  return resp['Data']
}

export const loadRentalsToLocalStorage = async (email: string) => {
  try {
    const data = {
      appname: 'tkd-score',
      reportname: 'Gen_3_Scoring_Rental_Report',
      criteria: '(Email == "' + email + '")',
    }
    const resp = await callWFAPI(0, 'zohoCreator', data)
    if (resp.length > 0) {
      let rentals = []
      for (let i = 0; i < resp.length; i++) {
        let rental = {
          id: resp[i].ID,
          date: resp[i].added,
          customerInfo: {
            email: resp[i].Email,
            eventName: resp[i].Event_Name,
            name: resp[i].Name,
            notes: resp[i].Notes,
            phone: resp[i].Phone_Number,
            shippingLocation: resp[i].Shipping_Location,
            proposedEventDate: resp[i].Proposed_Event_Date || '',
            alternateDate: resp[i].Alternate_Date || '',
          },
          total: parseFloat(resp[i].Total_Amount),
          subtotal: parseFloat(resp[i].Subtotal),
          tax: parseFloat(resp[i].California_Tax),
          selections: {
            gen3Body: resp[i].Gen3_Body_Quantity,
            gen3Head: resp[i].Gen3_Head_Quantity,
            gen3JudgesOnly: resp[i].Gen3_Judges_Only_Quantity,
            fullGen3Ring: resp[i].Full_Gen3_Ring_Quantity,
            requireTech:
              resp[i].Requires_Technician &&
              resp[i].Requires_Technician == 'true'
                ? true
                : false,
          },
        }
        rentals.push(rental)
      }
      localStorage.setItem('pendingRentals', JSON.stringify(rentals))
    }
  } catch (error) {}
}
